module.exports = __webpack_public_path__ + "static/media/FinanceBrokerIcon.541a4799.svg";